export const noticeError = (...args) =>
    window.newrelic &&
    window.newrelic.noticeError &&
    window.newrelic.noticeError(...args);
